/* eslint-disable class-methods-use-this */
/* eslint-disable prettier/prettier */
import apiClient from './apiClient';

export class HealthRepository {
    async fetchHealthStatus(region) {
        try {
            const response = await apiClient.get('/Kumaapi/status_pages', {
                params: { region }
            });
            if (response.data.success) {
                return response.data.data;
            }
            throw new Error(response.data.message || '獲取健康狀態失敗');
        } catch (error) {
            console.error('Error fetching health status:', error);
            throw new Error('無法連接到健康狀態服務');
        }
    }
}